export default function CTAAppel() {
  return (
    <section className="bg-brand-blue py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
          Votre volet électrique est en panne ?
        </h2>
        <p className="text-white/80 text-base md:text-lg mb-8 max-w-2xl mx-auto">
          Nos techniciens interviennent rapidement à Strasbourg et dans tout le Bas-Rhin pour réparer votre volet roulant électrique.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="tel:0374473240"
            className="flex items-center justify-center gap-2 bg-brand-cyan text-white px-7 py-3.5 rounded-md font-semibold text-base hover:bg-brand-cyan/90 transition-all duration-200 btn-hover-effect whitespace-nowrap w-full sm:w-auto sm:min-w-[260px]"
          >
            <span className="btn-icon-wrap"><i className="ri-phone-line text-lg"></i></span>
            Appeler le 03 74 47 32 40
          </a>
          <a
            href="#devis"
            className="inline-flex items-center justify-center gap-2 border-2 border-white text-white px-7 py-3.5 rounded-md font-semibold text-base hover:bg-white hover:text-brand-blue transition-colors whitespace-nowrap w-full sm:w-auto sm:min-w-[260px]"
          >
            <i className="ri-file-list-3-line text-lg"></i>
            Devis gratuit
          </a>
        </div>
      </div>
    </section>
  );
}